import React from "react"
import PropTypes from "prop-types"
import { chakra } from "@chakra-ui/react"

import "@fontsource/inter"
import "@fontsource/roboto"
import "../variables.css"
import "../global.css"

import Seo from "../seo"
import NavigationOld from "../navigation/"
import SubNavigation from "./sub-navigation"
import Footer from "../footer"

const styles = {
  main: {
    width: "100%",
    height: "100%",
  },
}

const Layout = ({
  children,
  hideNavigation,
  title,
  description,
  image,
  keywords,
  location,
  isResourceSite = false,
}) => {
  return (
    <>
      <Seo
        title={title}
        description={description}
        image={image}
        keywords={keywords}
      />

      <NavigationOld
        hideMenu={hideNavigation}
        location={location}
        sticky={false}
      />

      <SubNavigation location={location} isResourceSite={isResourceSite} />

      <chakra.main sx={styles.main}>{children}</chakra.main>

      {!hideNavigation && <Footer />}
    </>
  )
}

Layout.propTypes = {
  hideNavigation: PropTypes.bool,
}

export default Layout
